/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RequestState } from './requestState.model';
import { RequestConcernedEntity } from './requestConcernedEntity.model';
import { RequestKatuzeEntityDto } from './requestKatuzeEntityDto.model';


export interface RequestEntityDto { 
    createdTime?: string;
    finishedTime?: string;
    id?: number;
    knDataTo?: string;
    lpisDataTo?: string;
    name?: string;
    requestConcerned?: Array<RequestConcernedEntity>;
    requestKatuze?: Array<RequestKatuzeEntityDto>;
    state?: RequestState;
}
export namespace RequestEntityDto {
}


